var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TheUncle',{attrs:{"color":true,"title":"삼촌 게시판","description":"게시글 목록입니다."}},[_c('BroadcastUncle',{attrs:{"title":"게시글","broadcasts":_vm.broadcasts},on:{"refresh":_vm.refresh}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }